// API 配置工具，统一解析后端基础地址
const DEFAULT_API_BASE_URL = 'https://usvisa.lvbaobao.space';

export const getApiBaseUrl = () => {
  // 优先使用环境变量
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  if (envUrl) {
    return envUrl.replace(/\/$/, '');
  }

  // 其次使用当前站点域名，避免跨域（如 thai.usvisa 等子站）
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/$/, '');
  }

  // 最后回退到默认值
  return DEFAULT_API_BASE_URL;
};

export default getApiBaseUrl;
